import {
  OEA_LITE_PRODUCT_TYPE,
  OEA_PRODUCT_TYPE,
  OEC_PRODUCT_TYPE,
  OEC_TURBO_PRODUCT_TYPE,
  OES_PLUS_PRODUCT_TYPE,
  OES_PRODUCT_TYPE,
} from '.';

export const LOW_SPEED_OPTIMIZE_ENABLED = 1;
export const LOW_SPEED_OPTIMIZE_DISABLED = 2;

export const LOW_SPEED_OPTIMIZE_OPTIONS = [
  { value: LOW_SPEED_OPTIMIZE_DISABLED, label: '不开启' },
  { value: LOW_SPEED_OPTIMIZE_ENABLED, label: '开启' },
];

export const SAME_PROVINCE_ENABLED_STATUS = 2;

export const SCHEDULE_CONFIG_LABELS = {
  sameProvince: '同省调度',
  lowSpeed: '低速带宽优化',
};

export const LOW_SPEED_OPTIMIZE_UNSUPPORTED_ERROR = {
  iRet: 220010,
  sMsg: 'error[不支持此设备类型]',
};

export const OE_DEVICE_TYPES = [
  OEA_PRODUCT_TYPE,
  OEA_LITE_PRODUCT_TYPE,
  OEC_PRODUCT_TYPE,
  OEC_TURBO_PRODUCT_TYPE,
  OES_PRODUCT_TYPE,
  OES_PLUS_PRODUCT_TYPE,
];

export const SCHEDULE_CONFIG_DEVICE_TYPES = [OEA_PRODUCT_TYPE, OEA_LITE_PRODUCT_TYPE];

export const isOEDevice = productType => OE_DEVICE_TYPES.includes(productType);

export const isScheduleConfigDevice = productType =>
  SCHEDULE_CONFIG_DEVICE_TYPES.includes(productType);

export const shouldShowLegacyIntraProvincialRow = ({ intraProvincialFlag, productType } = {}) =>
  intraProvincialFlag === SAME_PROVINCE_ENABLED_STATUS && !isOEDevice(productType);

export const isLowSpeedOptimizeEnabled = enabled => enabled === LOW_SPEED_OPTIMIZE_ENABLED;

export const getLowSpeedOptimizeValue = enabled =>
  isLowSpeedOptimizeEnabled(enabled) ? LOW_SPEED_OPTIMIZE_ENABLED : LOW_SPEED_OPTIMIZE_DISABLED;

export const buildScheduleConfigLabels = ({
  intraProvincialStatus,
  lowSpeedEnabled,
  showSameProvince = true,
} = {}) => {
  const labels = [];

  if (showSameProvince && intraProvincialStatus === SAME_PROVINCE_ENABLED_STATUS) {
    labels.push(SCHEDULE_CONFIG_LABELS.sameProvince);
  }

  if (isLowSpeedOptimizeEnabled(lowSpeedEnabled)) {
    labels.push(SCHEDULE_CONFIG_LABELS.lowSpeed);
  }

  return labels;
};

export const isLowSpeedOptimizeUnsupportedError = error =>
  !!error &&
  error.iRet === LOW_SPEED_OPTIMIZE_UNSUPPORTED_ERROR.iRet &&
  error.sMsg === LOW_SPEED_OPTIMIZE_UNSUPPORTED_ERROR.sMsg;
